var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doPICTURETEXT"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cont.title))]),_c('div',{staticClass:"stem"},[_vm._v(" "+_vm._s(_vm.cont.stem))]),_c('img',{attrs:{"src":_vm.cont.answer}})])
}
var staticRenderFns = []

export { render, staticRenderFns }